// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

// ===== Interfaces =====

import {
    IPostCollabDocExportResult,
}                               from '../interfaces';

const exportPostCollaborativeDoc = async ({
    test,
    docId,
}: {
    test: boolean,
    docId: string,
}): Promise<IPostCollabDocExportResult> => {
    const functions = getFunctions();
    const callable = httpsCallable<
        Record<string, boolean | string>,
        IPostCollabDocExportResult
    >(
        functions,
        'exportPostCollaborativeDoc',
    );
    return callable({
        test,
        docId,
    }).then((result) => result.data as IPostCollabDocExportResult).catch((err) => {
        throw err;
    });
};

export default exportPostCollaborativeDoc;
